import ExperienceContainer from './experience_container';

const Experience = ExperienceContainer;
export default Experience;
